import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import { Spin } from 'antd'
import Button from '@components/ui/Button'
import Modal from '@components/ui/Modal'
import { useMineInfo } from '@/auth/useMineInfo'
import useCompanyUrl from '@/hooks/useCompanyUrl'
import useSimpleMode from '@/hooks/useSimpleMode'
import { SIMPLE_MODE_ENTRANCE, STATIONARY_COMBUSTION_MANAGEMENT } from '@/routes'
import localStorageUtil from '@/utils/localstorage'

const TokenVerify = () => {
  const { t } = useTranslation('common')
  const location = useLocation()
  const history = useHistory()

  const { isUsedSimpleModeByUser } = useSimpleMode()
  const companyUrl = useCompanyUrl()
  const { refetch: getUserMineInfo } = useMineInfo()

  const clearTokenFromUrl = () => {
    const url = new URL(window.location.href)
    url.searchParams.delete('token')
    history.replace(url.pathname + url.search)
  }

  const directToPage = (userInfo: any) => {
    let defaultPage = ''
    if (userInfo?.companyObj) {
      if (isUsedSimpleModeByUser(userInfo)) {
        defaultPage = companyUrl.urlReplacer(SIMPLE_MODE_ENTRANCE, userInfo.companyObj?.companyCode)
      } else {
        defaultPage = companyUrl.urlReplacer(
          STATIONARY_COMBUSTION_MANAGEMENT,
          userInfo.companyObj?.companyCode
        )
      }
    }
    clearTokenFromUrl()
    history.push(defaultPage)
  }

  const redirectToLoginURL = () => {
    history.push('/')
  }

  const [isVerifyError, setVerifyError] = React.useState(false)

  React.useEffect(() => {
    const params = new URLSearchParams(location.search)
    const token = params.get('token')
    if (token) {
      localStorageUtil.set('token', token)
      getUserMineInfo()
      directToPage({ companyObj: null }) // 這裡 companyObj 可根據你的業務邏輯調整
      setVerifyError(false)
    } else {
      setVerifyError(true)
      redirectToLoginURL()
    }
  }, [location]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Modal visible centered footer={null} closable={false}>
        <div className="text-center">
          {isVerifyError ? (
            <>
              <div className="text-danger font-bold text-lg mb-10">{t('verifyFailed')}</div>
              <Button onClick={() => redirectToLoginURL()}>{t('verifyAgain')}</Button>
            </>
          ) : (
            <>
              <Spin />
              <label className="mx-10 font-bold text-lg">{t('verifyInprocess')}</label>
            </>
          )}
        </div>
      </Modal>
    </>
  )
}

export default TokenVerify
